import parse from "html-react-parser";

var _ = require('lodash');

export default function Nl2Br(props) {
    const { text } = props;

    const nl2br = (str, is_xhtml) => {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        let s = (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
        return s.replace(/(http[^\s|^\<]*)/g, "<a href='$1' target='_blank' rel='noopener noreferrer' >$1</a>")
    }
    return (<span>{parse(nl2br(text))}</span>)
}